import { Banner, Typography } from "@bca/ui-library";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import degradedServicesErrorDataPush from "../AdobeDataPushes/errors/degradedServicesErrorDataPush";

import getEnvironment from "../getEnvironment";

interface DegradedServiceBannerProps {
  degradedServices?: string[];
}

const DegradedServicesBanner: React.FunctionComponent<
  DegradedServiceBannerProps
> = ({ degradedServices }) => {
  const router = useRouter();
  const environment = getEnvironment();
  const isProd = environment === "production";

  const contactLink = isProd
    ? "https://bca.co.uk/contact"
    : "https://cms.uat.britishcarauctions.net/contact";

  const [showBanner, setShowBanner] = useState<boolean>(false);

  const hideBanner = () => setShowBanner(false);
  const refresh = () => {
    hideBanner();
    router.reload();
  };

  useEffect(() => {
    if (
      degradedServices.length === 1 &&
      Object.keys(bannerConfig).includes(degradedServices[0])
    ) {
      setShowBanner(true);
      degradedServicesErrorDataPush(
        bannerConfig[degradedServices[0]].analyticsMessage
      );
    } else {
      setShowBanner(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [degradedServices]);

  const bannerConfig = {
    DeliveryService: {
      title: "Delivery Service currently unavailable.",
      message:
        "We’ve encountered an unexpected technical issue. Please refresh the page to try again, or check back later.",
      analyticsMessage: "delivery service currently unavailable",
    },
    InvoiceService: {
      title: "Payment and Transport Services currently unavailable.",
      message:
        "We’ve encountered an unexpected technical issue. Please refresh the page to try again, or check back later. If this error persists please contact customer support.",
      analyticsMessage: "payment and transport services currently unavailable",
    },
    GetOpenBankingLinkError: {
      title: "Payment and Transport Services currently unavailable.",
      message:
        "We’ve encountered an unexpected technical issue. Please refresh the page to try again, or check back later. If this error persists please contact customer support.",
      analyticsMessage: "payment and transport services currently unavailable",
    },
    OpenBankingService: {
      title: "Payment and Transport Services currently unavailable.",
      message:
        "We’ve encountered an unexpected technical issue. Please refresh the page to try again, or check back later. If this error persists please contact customer support.",
      analyticsMessage: "payment services currently unavailable",
    },
    CollectionService: {
      title: "Collection Service currently unavailable.",
      message:
        "We’ve encountered an unexpected technical issue. Please refresh the page to try again, or check back later.",
      analyticsMessage: "collection service currently unavailable",
    },
    MediaServerService: {
      title: "Image Download and Reports currently unavailable.",
      message:
        "We’ve encountered an unexpected technical issue. Please refresh the page to try again, or check back later.",
      analyticsMessage: "image download and reports currently unavailable",
    },
  };

  const primaryLinkAnalytics = {
    eventName: "click",
    eventCategory: "button",
    eventLabel: "refresh",
    eventAction: "refresh",
    eventSection: "error-banner",
  };

  const secondaryLinkAnalytics = {
    eventName: "click",
    eventCategory: "link",
    eventLabel: "contact-us",
    eventAction: "navigate",
    eventSection: "error-banner",
  };

  return (
    <>
      {showBanner && (
        <Banner
          primaryLinkType="button"
          primaryLinkLabel="Refresh"
          primaryLinkAction={refresh}
          secondaryLinkType="link"
          secondaryLinkLabel="Contact Us"
          secondaryLinkUrl={contactLink}
          secondaryLinkOpenInNewTab
          variant="error"
          title={bannerConfig[degradedServices[0]].title}
          titleColor="grey-blue"
          position="absolute"
          primaryLinkAnalytics={primaryLinkAnalytics}
          secondaryLinkAnalytics={secondaryLinkAnalytics}
        >
          <Typography margin={0} mt="6px" variant="body" color="grey-blue">
            {bannerConfig[degradedServices[0]].message}
          </Typography>
        </Banner>
      )}{" "}
    </>
  );
};

export default DegradedServicesBanner;
